import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CategoryType } from 'pop-up/submit-phone-call/callcenter-call-submission/call-submission-form/call-submission-form-content/lead-and-source-submission-form/types/category-type';

import OperatorExtension from '../call-detail/types';

type CrmDataType = {
  productTypes: CategoryType[];
  operators: OperatorExtension[];
};

const initialState: CrmDataType = {
  productTypes: [],
  operators: []
};

const crmData = createSlice({
  name: 'productTypes',
  initialState,
  reducers: {
    setProductTypes(state, { payload }: PayloadAction<CategoryType[]>) {
      state.productTypes = payload;
    },
    setOperators(state, { payload }: PayloadAction<OperatorExtension[]>) {
      state.operators = payload;
    }
  }
});

export const { setProductTypes, setOperators } = crmData.actions;
export default crmData.reducer;
